import React from 'react';
export function AIPattern() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-29">
      {/* Hero Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/k1uCwXbhLhDZMPv5asmz3h/anton-maksimov-5642-su-qM37iptlCNY-unsplash.jpg')`,
      backgroundAttachment: 'fixed'
    }} data-id="element-30" />

      {/* Dark Overlay for Readability */}
      <div className="absolute inset-0 bg-carbon/85" data-id="element-31" />

      {/* Gradient Overlay for Depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-carbon/90 via-neural-green/20 to-carbon/95" data-id="element-32" />

      {/* Subtle Vignette Effect */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-carbon/60" data-id="element-33" />

      {/* Grid Background (Lighter for visibility) */}
      <div className="absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, #3EF0D1 1px, transparent 1px), linear-gradient(to bottom, #3EF0D1 1px, transparent 1px)`,
      backgroundSize: '4rem 4rem',
      maskImage: 'radial-gradient(circle at center, black, transparent 80%)'
    }} data-id="element-34" />

      {/* Subtle Glowing Orbs/Nodes - Animated */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-ai-teal/10 rounded-full blur-[120px] animate-pulse-slow" data-id="element-35" />
      <div className="absolute bottom-1/3 right-1/4 w-[30rem] h-[30rem] bg-neural-green/15 rounded-full blur-[150px] animate-pulse-slow delay-700" data-id="element-36" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-muted-gold/8 rounded-full blur-[180px] animate-pulse-slow delay-300" data-id="element-37" />

      {/* Abstract Lines / Circuit Pattern */}
      <svg className="absolute inset-0 w-full h-full opacity-[0.02]" xmlns="http://www.w3.org/2000/svg" data-id="element-38">
        <defs data-id="element-39">
          <pattern id="circuit-pattern" width="200" height="200" patternUnits="userSpaceOnUse" data-id="element-40">
            <path d="M 100 0 L 100 200 M 0 100 L 200 100" stroke="currentColor" strokeWidth="0.5" className="text-ai-teal" data-id="element-41" />
            <circle cx="100" cy="100" r="2" fill="currentColor" className="text-muted-gold" data-id="element-42" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#circuit-pattern)" data-id="element-43" />
      </svg>

      {/* Noise Texture Overlay for Film Grain Feel */}
      <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-44" />
    </div>;
}